import { useState, useEffect } from "react";

export default function ClassSearch({
	state,
	setState,
	errorState,
	setErrorState,
	classNumList,
	instructorClasses,
	colspan,
}) {
	const [courseList, setCourseList] = useState([]);
	const [selectOtherClasses, setSelectOtherClasses] = useState(false);
	const [searchString, setSearchString] = useState("");

	useEffect(() => {
		if (searchString.length > 0) {
			const filteredCourses = classNumList.filter(
				(item) =>
					item.label.toLowerCase().includes(searchString.toLowerCase()) ||
					(item.name && item.name.toLowerCase().includes(searchString.toLowerCase())),
			);
			setCourseList(filteredCourses);
		} else {
			setCourseList(classNumList);
		}
	}, [searchString, classNumList]);

	const handleChangeSelectClass = (classItem) => {
		const value = classItem.value;

		if (typeof state.class_ids === "object" && state.class_ids.includes(Number(value))) {
			const class_ids = state.class_ids.filter((item) => Number(item) !== Number(value));
			setState({
				...state,
				class_ids,
				term: classItem.term_value,
				courseTitle: classItem.label,
			});
			setErrorState((prev) => ({ ...prev, classNum: false }));
			// if (class_ids.length <= 1) {
			// 	setMultiple(false);
			// }
		} else {
			const classObject = classNumList.find((item) => item.value === Number(value));
			if (classObject?.combine) {
				const combine_ids = classObject.combine.split(",").map(Number);
				setState((prev) => ({
					...prev,
					class_ids: [...prev.class_ids, Number(value)],
					combineIds: [...(prev.combineIds || []), ...combine_ids],
					term: classItem.term_value,
					courseTitle: classItem.label,
				}));
			} else {
				setState((prev) => ({
					...prev,
					class_ids: [...prev.class_ids, Number(value)],
					term: classItem.term_value,
					courseTitle: classItem.label,
				}));
			}

			setErrorState((prev) => ({ ...prev, classNum: false }));
		}
	};
	console.log("classsearch", classNumList);
	return (
		<div className={`col-span-${colspan} border-gray-200 border rounded shadow p-4 gap-2`}>
			<label htmlFor="class_ids" className="col-span-3 font-medium text-primary ">
				Select your class(es) from the list below:
			</label>
			<div
				className={`flex flex-col gap-2 mt-2 ${
					errorState.classNum ? "border-red-500 border-2" : ""
				}`}
			>
				{!selectOtherClasses && instructorClasses && instructorClasses.length >= 1 && (
					<div className="flex flex-col gap-2 max-h-[40dvh] overflow-y-scroll pr-2 pl-[3px] py-[3px]  font-medium">
						{instructorClasses.map((classItem) => (
							<label
								key={classItem.value}
								htmlFor={classItem.value}
								className="flex items-center gap-2 border-2 rounded-md px-2 py-1 cursor-pointer bg-white"
							>
								<input
									type="checkbox"
									id={classItem.value}
									name="class_ids"
									value={classItem.value}
									onChange={() => handleChangeSelectClass(classItem)}
									checked={
										(typeof state.class_ids === "object" &&
											state.class_ids.includes(classItem.value)) ||
										(typeof state.class_ids === "number" && state.class_ids === classItem.value)
									}
								/>
								<div className="grid grid-cols-3 w-full max-h-[25px]">
									<span className="">{classItem.label}</span>
									<p className="text-sm font-normal">{classItem.name}</p>
									<div className="">
										<span
											className={`text-xs font-normal rounded-md px-1 bg-opacity-80 w-10 ${
												classItem?.term?.includes("Fall")
													? "bg-primary text-white"
													: classItem?.term?.includes("Winter")
														? "bg-secondaryIndigo"
														: classItem?.term?.includes("Spring")
															? "bg-secondaryOrange"
															: "bg-secondaryRed"
											}`}
										>
											{classItem.term}
										</span>
									</div>
								</div>
							</label>
						))}
						<label className="flex items-center gap-2 underline  py-1 cursor-pointer text-gray-500 col-span-3 text-xs">
							<button onClick={() => setSelectOtherClasses(!selectOtherClasses)}>
								Click here to select other classes from the department
							</button>
						</label>
					</div>
				)}
				{(selectOtherClasses || !instructorClasses || instructorClasses.length === 0) && (
					<div className="pl-[3px]">
						<input
							type="text"
							autoComplete="off"
							placeholder="Start typing here to filter for class or instructor"
							className="rounded-sm px-2 py-2 placeholder:font-semibold placeholder:text-gray-500 focus:ring-primary focus:ring-2 border-0 outline-none w-full ring-2"
							value={searchString}
							onChange={(e) => setSearchString(e.target.value)}
						/>
					</div>
				)}
				{(selectOtherClasses ||
					!instructorClasses ||
					(instructorClasses && instructorClasses.length === 0)) && (
					<div className="flex flex-col gap-2 max-h-[40dvh] overflow-y-scroll pr-2 pl-[3px] py-[3px] font-medium">
						{courseList.length >= 1 &&
							courseList.map((classItem, index) => (
								<label
									key={index}
									htmlFor={classItem.value}
									className={` bg-gray-100 border-[1px] flex items-center gap-2  rounded-md px-2 py-1 cursor-pointer hover:ring-2 ${
										state.class_ids === classItem.value || state.class_ids.includes(classItem.value)
											? "ring-primary ring-2"
											: ""
									}`}
								>
									<input
										type="checkbox"
										className=""
										id={classItem.value}
										name="class_ids"
										value={classItem.value}
										onChange={() => handleChangeSelectClass(classItem)}
										checked={
											(typeof state.class_ids === "object" &&
												state.class_ids.includes(classItem.value)) ||
											(typeof state.class_ids === "number" && state.class_ids === classItem.value)
										}
									/>
									<div className="grid grid-cols-3 w-full max-h-[25px]">
										<span className="self-start flex items-center">{classItem.label}</span>
										<p className="text-sm font-normal items-center flex">{classItem.name}</p>
										<div className="flex justify-end items-center">
											<span
												className={`text-xs font-normal rounded-md px-1 bg-opacity-80  ${
													classItem?.term?.includes("Fall")
														? "bg-primary text-white"
														: classItem?.term?.includes("Winter")
															? "bg-secondaryIndigo"
															: classItem?.term?.includes("Spring")
																? "bg-secondaryOrange"
																: "bg-secondaryRed"
												}`}
											>
												{classItem.term}
											</span>
										</div>
									</div>
								</label>
							))}
					</div>
				)}
				{state.class_ids && state.class_ids.length >= 1 && (
					// display selected classes
					<div className="border-primary border-2 p-2 rounded-md flex items-center gap-4">
						<span className="font-semibold">Classes Selected: </span>
						<div className="flex flex-wrap gap-2 ">
							{state.class_ids.map((item) => {
								return (
									<div key={item} className="bg-primary text-white rounded-md px-2 py-1 relative">
										{classNumList?.find((classItem) => classItem.value === Number(item))?.label
											? classNumList.find((classItem) => classItem.value === Number(item)).label
											: `${item} (Not Found, Requisition is likely from an old term)`}
										<button
											onClick={() =>
												handleChangeSelectClass({
													value: item,
												})
											}
											className="absolute -top-2 -right-2 bg-white text-red-500 rounded-full w-5 h-5 flex items-center justify-center font-bold hover:bg-red-500 hover:text-white"
										>
											-
										</button>
									</div>
								);
							})}
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
